import React, { useEffect } from 'react';
import { Grid, makeStyles, Modal, Paper } from '@material-ui/core';
import { Typography } from 'antd';
import CustomButton from '../../../../control/button/Button';

const useStyles = makeStyles((theme) => ({
    modalLabel: {
        fontSize: '20px',
        fontWeight: '700',
    },
    modalValue: {
        fontWeight: '400',
    },
    label: {
        fontSize: '30px',
        fontWeight: '400',
        paddingBottom: '4px',
    },
    btnCancel: {
        backgroundColor: '#808080 !important',
        width: '140px',
    },
    btnRegister: {
        width: '140px',
    },
    btnCancelReserve: {
        backgroundColor: `${theme.mainTheme.color3} !important`,
        width: '140px',
    },
    paper: {
        overflowY: 'auto',
        overflowX: 'hidden',
        backgroundColor: theme.palette.background.paper,
        padding: '44px',
        width: '70%',
        [theme.breakpoints.down('xs')]: {
            width: '90%',
            padding: '24px',
        },
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainBody: {
        '& .MuiGrid-item': {
            padding: 0,
        },
    },
    footer: {
        paddingTop: '40px',
    },
}));

const ModalRegister = ({
    infoCurrentRow,
    handleCloseInfoModal,
    handleRegister,
    eventData,
    isEventOver,
    canCancelReserve,
    handleCancelReserve,
}) => {
    const classes = useStyles();

    return (
        <Modal
            key={'registerModal'}
            open={!!infoCurrentRow}
            onClose={handleCloseInfoModal}
            className={classes.modal}
        >
            {infoCurrentRow && (
                <Paper className={classes.paper}>
                    <Grid container justify="center">
                        <Grid
                            container
                            className={classes.mainBody}
                            spacing={2}
                        >
                            <Grid item xs={12} md={12}>
                                <Typography variant="subtitle2">
                                    <label className={classes.label}>
                                        ตรวจสอบข้อมูลการลงทะเบียน
                                    </label>
                                </Typography>
                            </Grid>
                            {/* ถ้ามี empId จะเป็นพนักงานไม่มีจะเป็น บุคคลภายนอก */}
                            <Grid
                                item
                                md={infoCurrentRow.empId ? 6 : 12}
                                xs={12}
                            >
                                <div className={classes.modalLabel}>
                                    ประเภทผู้เข้าร่วมกิจกรรม :{' '}
                                    <span className={classes.modalValue}>
                                        {infoCurrentRow.empId
                                            ? 'พนักงานและลูกจ้างพนักงาน'
                                            : 'บุคคลภายนอก'}
                                    </span>
                                </div>
                            </Grid>
                            {infoCurrentRow.empId ? (
                                <>
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            รหัสพนักงาน :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.empId}
                                            </span>
                                        </div>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            ชื่อ-นามสกุล :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.fullName}
                                            </span>
                                        </div>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            อีเมล :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.email}
                                            </span>
                                        </div>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            หน่วยงาน :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.companyName
                                                    ? infoCurrentRow.companyName
                                                    : '-'}
                                            </span>
                                        </div>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            ตำแหน่งงาน :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.position
                                                    ? infoCurrentRow.position
                                                    : '-'}
                                            </span>
                                        </div>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            สายงาน :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.path
                                                    ? infoCurrentRow.path
                                                    : '-'}
                                            </span>
                                        </div>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            ฝ่าย :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.department
                                                    ? infoCurrentRow.department
                                                    : '-'}
                                            </span>
                                        </div>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            กอง :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.division
                                                    ? infoCurrentRow.division
                                                    : '-'}
                                            </span>
                                        </div>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            แผนก :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.section
                                                    ? infoCurrentRow.section
                                                    : '-'}
                                            </span>
                                        </div>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            วัน/เวลาที่ลงทะเบียนล่วงหน้า :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.reserveAt}
                                            </span>
                                        </div>
                                    </Grid>
                                    {infoCurrentRow.checkinAt &&
                                        eventData &&
                                        eventData.isRequiredCheckin && (
                                            <Grid item md={6} xs={12}>
                                                <div
                                                    className={
                                                        classes.modalLabel
                                                    }
                                                >
                                                    วัน/เวลาที่ลงทะเบียนเข้างาน
                                                    :{' '}
                                                    <span
                                                        className={
                                                            classes.modalValue
                                                        }
                                                    >
                                                        {
                                                            infoCurrentRow.checkinAt
                                                        }
                                                    </span>
                                                </div>
                                            </Grid>
                                        )}
                                </>
                            ) : (
                                <>
                                    {' '}
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            ชื่อ-นามสกุล :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.fullName}
                                            </span>
                                        </div>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            อีเมล :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.email}
                                            </span>
                                        </div>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            หน่วยงาน :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.companyName
                                                    ? infoCurrentRow.companyName
                                                    : '-'}
                                            </span>
                                        </div>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            ตำแหน่งงาน :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.position
                                                    ? infoCurrentRow.position
                                                    : '-'}
                                            </span>
                                        </div>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <div className={classes.modalLabel}>
                                            วัน/เวลาที่ลงทะเบียนล่วงหน้า :{' '}
                                            <span
                                                className={classes.modalValue}
                                            >
                                                {infoCurrentRow.reserveAt}
                                            </span>
                                        </div>
                                    </Grid>
                                    {infoCurrentRow.checkinAt &&
                                        eventData &&
                                        eventData.isRequiredCheckin && (
                                            <Grid item md={6} xs={12}>
                                                <div
                                                    className={
                                                        classes.modalLabel
                                                    }
                                                >
                                                    วัน/เวลาที่ลงทะเบียนเข้างาน
                                                    :{' '}
                                                    <span
                                                        className={
                                                            classes.modalValue
                                                        }
                                                    >
                                                        {
                                                            infoCurrentRow.checkinAt
                                                        }
                                                    </span>
                                                </div>
                                            </Grid>
                                        )}
                                </>
                            )}
                        </Grid>
                        <Grid
                            container
                            spacing={2}
                            justify="center"
                            className={classes.footer}
                        >
                            <Grid item>
                                <CustomButton
                                    label="ปิด"
                                    onClick={handleCloseInfoModal}
                                    className={classes.btnCancel}
                                />
                            </Grid>
                            {canCancelReserve && (
                                <Grid item>
                                    <CustomButton
                                        label="ยกเลิก"
                                        onClick={() => {
                                            handleCancelReserve(infoCurrentRow);
                                        }}
                                        className={classes.btnCancelReserve}
                                    />
                                </Grid>
                            )}
                            {!infoCurrentRow.checkinAt ||
                                (infoCurrentRow.checkinAt === '-' &&
                                    eventData &&
                                    eventData.isRequiredCheckin &&
                                    !isEventOver && (
                                        <Grid item>
                                            <CustomButton
                                                label="ลงทะเบียนเข้างาน"
                                                onClick={() => {
                                                    handleRegister(
                                                        infoCurrentRow
                                                    );
                                                }}
                                                className={classes.btnRegister}
                                            />
                                        </Grid>
                                    ))}
                        </Grid>
                    </Grid>
                </Paper>
            )}
        </Modal>
    );
};

export default ModalRegister;
